import React from "react";
import { Link } from "react-scroll";

const Menu = () => {
  //const underlined = "border-b-[color:var(--Background,#ECECEC)]";
  return (
    <>
      <Link
        to="home"
        className="cursor-pointer hover:text-yellow-500 "
        activeClass="active"
        spy={true}
        smooth={true}
        offset={-70}
        duration={1000}
      >
        Home
      </Link>

      <Link
        to="features"
        className="cursor-pointer hover:text-yellow-500 "
        activeClass="active"
        spy={true}
        smooth={true}
        offset={-70}
        duration={1000}
      >
        Features
      </Link>
      <Link
        to="about"
        className="cursor-pointer hover:text-yellow-500 "
        activeClass="active"
        spy={true}
        smooth={true}
        offset={-70}
        duration={1000}
      >
        About
      </Link>
      <Link
        to="blog"
        className="cursor-pointer hover:text-yellow-500 "
        activeClass="active"
        spy={true}
        smooth={true}
        offset={-70}
        duration={1000}
      >
        Blog
      </Link>
      <Link
        to="contact"
        activeClass="active"
        spy={true}
        smooth={true}
        offset={-70}
        duration={1000}
        className="cursor-pointer md:px-6 md:py-2 md:font-bold md:text-primary md:bg-white md:rounded-lg hover:text-white hover:bg-primary hover:border"
      >
        Contact
      </Link>
    </>
  );
};

export default Menu;
